/**
 * @description 微信js sdk相关
 */
// import { objectToString } from '@vue/shared';
import { weiXinInit as weiXinInitBase } from './base';
import { DEFAULT_API_LIST, IGNORE_INIT_API_LIST } from './config';
import { WxInvokeReport } from './report';
/**
 * 初始化sdk的promise
 * 避免重复初始化
 */
let initPromise = null;
/**
 * 微信sdk初始化（权限校验）
 * 内部没有处理异常，外部可按需处理异常（无特殊需求，可不处理，因为设置分享文案是旁路功能，不应该影响主流程）
 * @param params
 * @returns
 */
export const weiXinInit = (params) => {
    if (!initPromise) {
        const { apiList = DEFAULT_API_LIST, getTicket, openTagList = [], enableReport = false } = params;
        initPromise = weiXinInitBase({
            apiList,
            getTicket,
            openTagList,
            enableReport,
        });
    }
    return initPromise;
};
/**
 * 确保ready后调用的invoke
 * @param params invoke调用参数
 */
export const safeInvoke = (message, options, callback, setting) => {
    wx.ready(() => {
        const reporter = new WxInvokeReport(message, setting?.isReportLog);
        reporter.invokeBefore(options);
        wx.invoke(message, options, (res) => {
            reporter.invokeAfter(res);
            if (callback) {
                callback(res);
            }
        });
    });
};
/**
 * 加了代理的微信 sdk
 * 目的：让调用方不需要关注wx.ready
 */
const proxyWx = () => {
    const newObject = {};
    Object.keys(wx).forEach((prop) => {
        newObject[prop] = wx[prop];
        Object.defineProperty(wx, prop, {
            get: () => {
                // wx 下的方法（除了 config、error、ready外）调用，必须在ready后
                if (typeof newObject[prop] === 'function' && !IGNORE_INIT_API_LIST.includes(prop)) {
                    return (...args) => {
                        wx.ready(() => {
                            console.log('wx ready, executing ', prop);
                            newObject[prop](...args);
                        });
                    };
                }
                return newObject[prop];
            },
        });
    });
    return wx;
};
proxyWx();
/**
 * @param params 设置分享信息（包括：朋友、QQ、朋友圈、QQ空间）·
 */
export const setShareInfo = async (params) => {
    console.log('setShareInfo...');
    const { title, desc, link, imgUrl } = params;
    // 将回调改成promise
    const p1 = new Promise((resolve, reject) => {
        // 把所有方法改成返回一个promise，改写success 和 fail（调用就方法，并resolve）
        wx.updateAppMessageShareData({
            title,
            desc,
            link,
            imgUrl,
            // 设置成功
            success: (res) => {
                console.log('updateAppMessageShareData success', res);
                resolve(res);
            },
            fail: (res) => {
                console.log('updateAppMessageShareData error', res);
                reject(res);
            },
        });
    });
    // 将回调改成promise
    const p2 = new Promise((resolve, reject) => {
        // 需在用户可能点击分享按钮前就先调用
        wx.updateTimelineShareData({
            title,
            link,
            imgUrl,
            // 设置成功
            success: (res) => {
                console.log('updateTimelineShareData success', res);
                resolve(res);
            },
            fail: (res) => {
                console.log('updateTimelineShareData error', res);
                reject(res);
            },
        });
    });
    return Promise.all([p1, p2]);
};
/**
 * 设置专属奖赏小程序分享内容
 * @param params
 */
export const setMpShareInfo = async (params) => {
    wx.miniProgram.postMessage({
        data: {
            title: params.title,
            linkUrl: params.link,
            imgUrl: params.imgUrl,
            query: {
                sharetype: 'miniprogram',
            },
        },
    });
};
/**
 * 禁用页面弹跳滚动
 * @param params 禁用弹跳滚动的位置信息
 */
export const disableBounceScroll = async (params) => {
    const { place = ['top', 'bottom'] } = params || {};
    return new Promise((resolve, reject) => {
        safeInvoke('disableBounceScroll', {
            place,
        }, (result) => {
            const message = result.err_msg || '';
            if (/:ok/.test(message)) {
                resolve(result);
            }
            else {
                reject(result);
            }
        });
    });
};
/**
 * 禁用分享到平台，只能分享给朋友
 * 'menuItem:share:appMessage'
 */
export function hideMenuSharePlatform() {
    return new Promise((resolve) => {
        safeInvoke('hideMenuItems', {
            menuList: [
                // 分享到QQ
                'menuItem:share:qq',
                // 收藏
                'menuItem:favorite',
                // 分享到 QQ 空间
                'menuItem:share:QZone',
                // 分享到微博
                'menuItem:share:weiboApp',
                // 分享到朋友圈
                'menuItem:share:timeline',
                // 分享到FB
                'menuItem:share:facebook',
                // 禁用分享到 QQ 浏览器
                'menuItem:openWithQQBrowser',
                // 禁用分享到 Safari 浏览器
                'menuItem:openWithSafari',
                // 禁用复制链接
                'menuItem:copyUrl',
            ],
        }, resolve);
    });
}
/**
 * 禁用复制链接
 */
export function hideMenuCopyUrl() {
    return new Promise((resolve) => {
        safeInvoke('hideMenuItems', {
            menuList: [
                // 禁用复制链接
                'menuItem:copyUrl',
            ],
        }, resolve);
    });
}
/** 关闭微信webview */
export function closeWindow() {
    return new Promise((resolve) => {
        safeInvoke('closeWindow', {}, resolve);
    });
}
export function showOptionMenu() {
    return new Promise((resolve) => {
        safeInvoke('showOptionMenu', {}, resolve);
    });
}
export function hideOptionMenu() {
    return new Promise((resolve) => {
        safeInvoke('hideOptionMenu', {}, resolve);
    });
}
/**
 * 拉起摄像头扫码
 * @returns
 */
export function scanQRCode() {
    const args = {
        needResult: 0,
        scanType: ['qrCode'],
    };
    return new Promise((resolve) => {
        safeInvoke('scanQRCode', args, resolve);
    });
}
//# sourceMappingURL=bridge.js.map